// import axios from "axios";
// import React, { useContext, useState } from "react";
// import { MdUpdate } from "react-icons/md";
// import { RiSignalWifi3Fill, RiSignalWifiOffLine } from "react-icons/ri";
// import { useHistory, useLocation } from "react-router-dom/cjs/react-router-dom";
// import { GlobalState } from "../../GlobalState.js";
// import ToggleButton from "../utils/ToggleButton";
// import Tooltip from "../utils/Tooltip.js";
// import { editAccess, formatDate } from "../utils/utils.js";
// import SolenoidDetailPage from "./solenoidDetail.js";
// import solenoid_image from "../../assets/images/solenoid_image.png";
// import { MdDeviceHub } from "react-icons/md";
// import { RadioTower } from "lucide-react";
// import styled, { css, keyframes } from "styled-components";


// const Container = styled.div`
//  box-shadow: 0 4px 12px rgba(0,0,0,0.2);
//   background-color: rgba(240,248,255,0.3);
//   border-radius: 20px;
//   display: flex;
//   flex-direction: column;
//   // cursor: pointer;
//   padding: 0.5rem;
//   position: relative;

//   // border: 2px solid #fff;
//   // background-color: #fff;
//   // &:hover {
//   //   border: 2px solid var(--primary);
//   // }
//   min-width: 260px;
//   margin: 0.3rem;
// `;
// const LocationName = styled.h5`
//   word-wrap: break-word;
//   max-width: 90%;
//   cursor: pointer;
// `;

// const TimeElapsed = styled.p`
//   margin: 0.5rem;
//   font-size: 0.7rem;
//   font-weight:bold;
//   text-align: end;
//   display: flex;
//   align-items: flex-end;
//   justify-content: space-between;
//   @media (min-width: 61.313em) {
//     text-align: end;
//   }
// `;

// const TopLine = styled.div`
//   display: flex;
//   align-items: left;
//   gap: 0.5rem;
// `;

// const BottomLine = styled.div`
//   display: flex;
//   align-items: center;
//   gap: 0.5rem;
//   justify-content: space-between;
//   margin-top: 0.5rem;
// `;

// const blinkingRed = keyframes`
//   0% { opacity: 1; }
//   50% { opacity: 0.3; }
//   100% { opacity: 1; }
// `;

// const BlinkingRadioTower = styled(RadioTower)`
//   color: red;
//   animation: ${blinkingRed} 2s infinite;
// `;
// const AnimatedIconWrapper = styled.div`
//   display: inline-flex;
//   justify-content: center;
//   align-items: center;
//   border-radius: 50%;
//   width: 28px;   
//   height: 28px;  
//   position: relative;

//   ${({ online }) =>
//     online
//       ? css`
//           &::after {
//             content: "";
//             position: absolute;
//             top: -2px;
//             left: -2px;
//             width: calc(100% + 4px);
//             height: calc(100% + 4px);
//             border-radius: 50%;
//             animation: ${ripple} 1.5s infinite;
//           }
//         `
//       : css`
//           &::after {
//             content: "";
//             position: absolute;
//             top: -2px;
//             left: -2px;
//             width: calc(100% + 4px);
//             height: calc(100% + 4px);
//             border-radius: 50%;
//             background-color: rgba(255, 0, 0, 0.1); /* red glow */
//           }
//         `}
// `;

// const AnimatedIcon = styled(RadioTower)`
//   width: 16px;
//   height: 16px;
//   ${({ online }) =>
//     online &&
//     css`
//       animation: ${pulse} 1.5s infinite;
//       color: green;
//     `}
// `;

// const pulse = keyframes`
//   0% { opacity: 0.6; }
//   50% { opacity: 1; }
//   100% { opacity: 0.6; }
// `;

// const ripple = keyframes`
//   0% { box-shadow: 0 0 0px 0px rgba(0, 200, 0, 0.5); }
//   100% { box-shadow: 0 0 0px 14px rgba(0, 200, 0, 0); }
// `;


// export default function SolenoidBoxComponent({ sensor }) {
//   const history = useHistory();

//   const location = useLocation();
//   const state = useContext(GlobalState);
//   const [solenoid, setSolenoid] = React.useState(sensor);
//   const {
//     solenoid_id,
//     valve_on,
//     sensor_online,
//     updatedAt,
//     motor_id,
//     sensor_id,
//   } = solenoid || {};

//   const [solenoidStatus, setSolenoidStatus] = React.useState(valve_on === "1");

//   const toggleSolenoid = async (id) => {
//     try {
//       setSolenoidStatus((prev) => !prev);

//       const response = await axios.patch(
//         `${process.env.REACT_APP_API}/sensor/solenoid?solenoid_id=${id}`,
//         { valve_on: !solenoidStatus ? "1" : "0" },
//         { headers: { Authorization: state.token[0] } }
//       );

//       if (response.data) {
//         await fetchData(id);
//       }
//     } catch (err) {
//       console.error("Error toggling solenoid:", err);
//       setSolenoidStatus((prev) => !prev);
//     }
//   };

//   const fetchData = async (id) => {
//     try {
//       const response = await axios.get(
//         `${process.env.REACT_APP_API}/sensor/solenoid?solenoid_id=${id}`,
//         { headers: { Authorization: state.token[0] } }
//       );

//       if (response.data?.data) {

//         setSolenoid(response.data.data);
//         setSolenoidStatus(response.data.data.valve_on === "1"); 
//       }
//     } catch (err) {
//       console.error("Error fetching solenoid data:", err);
//     }
//   };


//   React.useEffect(() => {
//     if (solenoid_id) {
//       fetchData(solenoid_id); 

//       const interval = setInterval(() => {
//         fetchData(solenoid_id);
//       }, 5000);

//       return () => clearInterval(interval);
//     }
//   }, [solenoid_id]);

//   return (
//     <>

//       <Container>
//         <TopLine>
//       <AnimatedIconWrapper online={sensor_online}>
//           {sensor_online ? (
//             <AnimatedIcon online size={16} strokeWidth={2} />
//           ) : (
//             <Tooltip content="Solenoid is offline." direction="right" delay="0">
//               <BlinkingRadioTower size={20} strokeWidth={2} color="red" />
//             </Tooltip>
//           )}
//         </AnimatedIconWrapper>

//           <LocationName
//             onClick={async () => {
//               try {
//                 // Ensure values are correctly passed and valid
//                 // if (!solenoid_id || !motor_id || !sensor_id) {
//                 //   console.error('Missing required params for navigation.');
//                 //   return;
//                 // }

//                 history.push(
//                   `/solenoid/${solenoid_id}/${sensor.location_name}`
//                 );
//               } catch (error) {
//                 console.error("Error navigating:", error);
//               }
//             }}
//           >
//             {sensor.location_name}
//           </LocationName>
//         </TopLine>
//         <TimeElapsed>
//           <div>
//             <MdUpdate /> &bull; &nbsp;
//             {formatDate(updatedAt)}
//           </div>
//           <ToggleButton
//           disabled={!editAccess(state.userAPI)}
//           id={solenoid_id}
//           checked={solenoidStatus}
//           onClick={(e) => e.stopPropagation()} 
//           onChange={() => toggleSolenoid(solenoid_id)}
//         />
//         </TimeElapsed>
//       </Container>
//     </>
//   );
// }


 
// import axios from "axios";
// import React, { useContext } from "react";
// import { useHistory } from "react-router-dom/cjs/react-router-dom";
// import { GlobalState } from "../../GlobalState.js";
// import ToggleButton from "../utils/ToggleButton";
// import { editAccess } from "../utils/utils.js";
// import styled, { keyframes, css } from "styled-components";

// const Container = styled.div`
//   border-radius: 20px;  
//   display: flex;
//   flex-direction: column;
//   padding: 0.5rem;
//   position: relative;
//   backdrop-filter: blur(2px);
//   min-width: 160px; 

//   @media (max-width: 1024px) {
//     width: 280px;
//     min-width: 280px;
//     max-width: 280px;
//   }

//   @media (max-width: 768px) {
//     width: 100%;
//     min-width: 180px;
//     max-width: 200px;
//      margin: 0 auto;
//   }
// `;

// const ToggleWrapper = styled.div`
//   grid-column: 1;
//   grid-row: 1;
//   display: flex;
//   align-items: center;
//   justify-content: flex-start;
// `;

// const OfflineBadgeWrapper = styled.div`
//   grid-column: 3;
//   grid-row: 1;
//   display: flex;
//   align-items: center;
//   justify-content: flex-end;
//    padding-right: 20px;
// `;

// const gradientShift = keyframes`
//   0% {
//     background-position: -200% center;
//   }
//   100% {
//     background-position: 200% center;
//   }
// `;

// const pulse = keyframes`
//   0%, 100% { 
//     transform: scale(1);
//   }
//   50% { 
//     transform: scale(1.05);
//   }
// `;

// const LocationName = styled.p`
//   margin: 0;
//   opacity: 0;
//   animation: fadeIn 0.4s ease forwards, ${gradientShift} 2.5s linear infinite, ${pulse} 2s ease-in-out infinite;
//   font-weight: 1000;
//   white-space: nowrap;
//   font-size: 0.9rem;
//   cursor: pointer;

//   ${({ $isFaulty, $isOnline }) =>
//     $isFaulty
//       ? css`
//           /* 🔴 FAULTY: Red with BRIGHT YELLOW shiny */
//           background: linear-gradient(
//             90deg,
//             #ef4444 0%,
//             #ef4444 30%,
//             #ffeb3b 50%,
//             #ef4444 70%,
//             #ef4444 100%
//           );
//           background-size: 200% auto;
//           background-clip: text;
//           -webkit-background-clip: text;
//           -webkit-text-fill-color: transparent;
//         `
//       : $isOnline
//       ? css`
//           /* 🟢 ONLINE: Green with BRIGHT CYAN shiny */
//           background: linear-gradient(
//             90deg,
//             #5ca904 0%,
//             #5ca904 30%,
//             #00ffff 50%,
//             #5ca904 70%,
//             #5ca904 100%
//           );
//           background-size: 200% auto;
//           background-clip: text;
//           -webkit-background-clip: text;
//           -webkit-text-fill-color: transparent;
//         `
//       : css`
//           /* 🟠 OFFLINE: Orange with BRIGHT BLUE shiny */
//           background: linear-gradient(
//             90deg,
//             #ea580c 0%,
//             #ea580c 30%,
//             #00bfff 50%,
//             #ea580c 70%,
//             #ea580c 100%
//           );
//           background-size: 200% auto;
//           background-clip: text;
//           -webkit-background-clip: text;
//           -webkit-text-fill-color: transparent;
//         `}

//   @keyframes fadeIn {
//     to {
//       opacity: 1;
//     }
//   }
// `;

// const StatusBadge = styled.div`
//   padding: 2px 8px;
//   border-radius: 4px;
//   font-size: 0.65rem;
//   font-weight: 600;
//   white-space: nowrap;
//   color: white;
//   background-color: #fb923c;
//   box-shadow: 0 1px 2px rgba(249, 115, 22, 0.2);

//   @media (max-width: 1024px) {
//     font-size: 0.6rem;
//     padding: 2px 7px;
//   }

//   @media (max-width: 768px) {
//     font-size: 0.55rem;
//     padding: 1px 6px;
//   }
// `;

// const TopRow = styled.div`
//   width: 100%;
//   display: flex;
//   align-items: center;      /* centers vertically */
//   justify-content: space-between; 
// gap:20px/* pulls badge inward nicely */
// `;


// export default function SolenoidBoxComponent({ sensor }) {
//   const history = useHistory();
//   const state = useContext(GlobalState);
//   const [solenoid, setSolenoid] = React.useState(sensor);

//   const {
//     solenoid_id,
//     valve_on,
//     sensor_online,
//   } = solenoid || {};

//   const [solenoidStatus, setSolenoidStatus] = React.useState(valve_on === "1");
//   const isOnline = sensor_online;

//   // const toggleSolenoid = async (id) => {
//   //   try {
//   //     setSolenoidStatus((prev) => !prev);

//   //     const response = await axios.patch(
//   //       `${process.env.REACT_APP_API}/sensor/solenoid?solenoid_id=${id}`,
//   //       { valve_on: !solenoidStatus ? "1" : "0" },
//   //       { headers: { Authorization: state.token[0] } }
//   //     );

//   //     if (response.data) {
//   //       await fetchData(id);
//   //     }
//   //   } catch (err) {
//   //     console.error("Error toggling solenoid:", err);
//   //     setSolenoidStatus((prev) => !prev);
//   //   }
//   // };

//   // const fetchData = async (id) => {
//   //   try {
//   //     const response = await axios.get(
//   //       `${process.env.REACT_APP_API}/sensor/solenoid?solenoid_id=${id}`,
//   //       { headers: { Authorization: state.token[0] } }
//   //     );
//   //     if (response.data?.data) {
//   //       setSolenoid(response.data.data);
//   //       setSolenoidStatus(response.data.data.valve_on === "1");
//   //     }
//   //   } catch (err) {
//   //     console.error("Error fetching solenoid data:", err);
//   //   }
//   // };

//   const toggleSolenoid = async (id) => {
//   try {
//     setSolenoidStatus((prev) => !prev);
//     console.log("Toggling solenoid. Previous status:", solenoidStatus);

//     const response = await axios.patch(
//       `${process.env.REACT_APP_API}/sensor/solenoid?solenoid_id=${id}`,
//       { valve_on: !solenoidStatus ? "1" : "0" },
//       { headers: { Authorization: state.token[0] } }
//     );

//     console.log("Toggle response:", response.data);

//     if (response.data) {
//       await fetchData(id);
//     }
//   } catch (err) {
//     console.error("Error toggling solenoid:", err);
//     setSolenoidStatus((prev) => !prev);
//   }
// };

// const fetchData = async (id) => {
//   try {
//     const response = await axios.get(
//       `${process.env.REACT_APP_API}/sensor/solenoid?solenoid_id=${id}`,
//       { headers: { Authorization: state.token[0] } }
//     );

//     console.log("Fetched solenoid:", response.data?.data);

//     if (response.data?.data) {
//       setSolenoid(response.data.data);
//       setSolenoidStatus(response.data.data.valve_on === "1");
//       console.log(
//         `Updated solenoid state: valve_on=${response.data.data.valve_on}, sensor_online=${response.data.data.sensor_online}, updatedAt=${response.data.data.updatedAt}`
//       );
//     }
//   } catch (err) {
//     console.error("Error fetching solenoid data:", err);
//   }
// };


//   React.useEffect(() => {
//     if (solenoid_id) {
//       fetchData(solenoid_id);

//       const interval = setInterval(() => {
//         fetchData(solenoid_id);
//       }, 5000);

//       return () => clearInterval(interval);
//     }
//   }, [solenoid_id]);

//   return (
//     <Container>
//         <TopRow>
//         <ToggleButton
//           disabled={!editAccess(state.userAPI)}
//           id={solenoid_id}
//           checked={solenoidStatus}
//           onClick={(e) => e.stopPropagation()}
//           onChange={() => toggleSolenoid(solenoid_id)}
//         />

//       {/* <OfflineBadgeWrapper>
//         {!isOnline && <StatusBadge>Offline</StatusBadge>}
//       </OfflineBadgeWrapper> */}

// <OfflineBadgeWrapper>
//   {solenoid && solenoid.sensor_online === false && solenoid.updatedAt && (
//     <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end" }}>
//       <StatusBadge>Offline</StatusBadge>
//       <small style={{ fontSize: "0.65rem", color: "#f0f0f0", marginTop: "2px" }}>
//         Since: {new Date(solenoid.updatedAt).toLocaleString()}
//       </small>
//     </div>
//   )}
// </OfflineBadgeWrapper>


//       </TopRow>
//       {/* <LocationName
//         $isOnline={isOnline}
//         onClick={() => {
//           history.push(`/solenoid/${solenoid_id}/${sensor.location_name}`);
//         }}
//       >
//         {sensor.location_name}
//       </LocationName> */}
//       <LocationName $isOnline={solenoid.sensor_online}>
//   {solenoid.location_name}
// </LocationName>


//     </Container>
//   );
// }




// import axios from "axios";
// import React, { useContext } from "react";
// import { useHistory } from "react-router-dom/cjs/react-router-dom";
// import { GlobalState } from "../../GlobalState.js";
// import ToggleButton from "../utils/ToggleButton";
// import { editAccess, formatDate } from "../utils/utils.js";
// import styled, { keyframes, css } from "styled-components";

// const Container = styled.div`
//   border-radius: 20px;  
//   display: flex;
//   flex-direction: column;
//   padding: 0.5rem;
//   position: relative;
//   backdrop-filter: blur(2px);
//   min-width: 160px; 
// `;

// const OfflineBadgeWrapper = styled.div`
//   display: flex;
//   flex-direction: column;
//   align-items: flex-end;
//   padding-right: 20px;
// `;

// const gradientShift = keyframes`
//   0% { background-position: -200% center; }
//   100% { background-position: 200% center; }
// `;

// const pulse = keyframes`
//   0%, 100% { transform: scale(1); }
//   50% { transform: scale(1.05); }
// `;

// const LocationName = styled.p`
//   margin: 0;
//   opacity: 0;
//   animation: fadeIn 0.4s ease forwards, ${gradientShift} 2.5s linear infinite, ${pulse} 2s ease-in-out infinite;
//   font-weight: 1000;
//   white-space: nowrap;
//   font-size: 0.9rem;
//   cursor: pointer;

//   ${({ $isOnline }) =>
//     $isOnline
//       ? css`
//           background: linear-gradient(90deg, #5ca904 0%, #5ca904 30%, #00ffff 50%, #5ca904 70%, #5ca904 100%);
//           background-size: 200% auto;
//           background-clip: text;
//           -webkit-background-clip: text;
//           -webkit-text-fill-color: transparent;
//         `
//       : css`
//           background: linear-gradient(90deg, #ea580c 0%, #ea580c 30%, #00bfff 50%, #ea580c 70%, #ea580c 100%);
//           background-size: 200% auto;
//           background-clip: text;
//           -webkit-background-clip: text;
//           -webkit-text-fill-color: transparent;
//         `}
  
//   @keyframes fadeIn { to { opacity: 1; } }
// `;

// const StatusBadge = styled.div`
//   padding: 2px 8px;
//   border-radius: 4px;
//   font-size: 0.65rem;
//   font-weight: 600;
//   white-space: nowrap;
//   color: white;
//   background-color: #fb923c;
//   text-align: center;
// `;

// export default function SolenoidBoxComponent({ sensor }) {
//   const history = useHistory();
//   const state = useContext(GlobalState);

//   const [solenoid, setSolenoid] = React.useState({
//     ...sensor,
//     sensor_online: sensor.sensor_online === true || sensor.sensor_online === "1",
//   });
//   const [solenoidStatus, setSolenoidStatus] = React.useState(sensor.valve_on === "1");

//   const fetchData = async (id) => {
//     try {
//       const response = await axios.get(
//         `${process.env.REACT_APP_API}/sensor/solenoid?solenoid_id=${id}`,
//         { headers: { Authorization: state.token[0] } }
//       );

//       const data = response.data?.data;
//       if (data) {
//         setSolenoid({
//           solenoid_id: data.solenoid_id,
//           sensor_online: data.sensor_online === true || data.sensor_online === "1",
//           valve_on: data.valve_on,
//           updatedAt: data.updatedAt,
//           location_name: data.location_name || sensor.location_name,
//         });
//         setSolenoidStatus(data.valve_on === "1");
//       }
//     } catch (err) {
//       console.error("Error fetching solenoid data:", err);
//     }
//   };

//   const toggleSolenoid = async (id) => {
//     try {
//       setSolenoidStatus(prev => !prev);

//       const response = await axios.patch(
//         `${process.env.REACT_APP_API}/sensor/solenoid?solenoid_id=${id}`,
//         { valve_on: !solenoidStatus ? "1" : "0" },
//         { headers: { Authorization: state.token[0] } }
//       );

//       if (response.data) {
//         await fetchData(id);
//       }
//     } catch (err) {
//       console.error("Error toggling solenoid:", err);
//       setSolenoidStatus(prev => !prev);
//     }
//   };

//   React.useEffect(() => {
//     if (sensor.solenoid_id) {
//       fetchData(sensor.solenoid_id);
//       const interval = setInterval(() => fetchData(sensor.solenoid_id), 5000);
//       return () => clearInterval(interval);
//     }
//   }, [sensor.solenoid_id]);

//   return (
//     <Container>
//       <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
//         <ToggleButton
//           disabled={!editAccess(state.userAPI)}
//           id={solenoid.solenoid_id}
//           checked={solenoidStatus}
//           onClick={(e) => e.stopPropagation()}
//           onChange={() => toggleSolenoid(solenoid.solenoid_id)}
//         />

//         {(!solenoid.sensor_online && solenoid.updatedAt) && (
//           <OfflineBadgeWrapper>
//             <StatusBadge>Offline
//             <small>
//              {formatDate(solenoid.updatedAt)}
//             </small>
//             </StatusBadge>
//           </OfflineBadgeWrapper>
//         )}
//       </div>

//       <LocationName
//         $isOnline={solenoid.sensor_online}
//         onClick={() => history.push(`/solenoid/${solenoid.solenoid_id}/${solenoid.location_name}`)}
//       >
//         {solenoid.location_name || "Unknown Location"}
//       </LocationName>
//     </Container>
//   );
// }



// import axios from "axios";
// import React, { useContext } from "react";
// import { useHistory } from "react-router-dom/cjs/react-router-dom";
// import { GlobalState } from "../../GlobalState.js";
// import ToggleButton from "../utils/ToggleButton";
// import { editAccess, formatDate } from "../utils/utils.js";
// import styled, { keyframes, css } from "styled-components";

// const Container = styled.div`
//   border-radius: 20px;  
//   display: flex;
//   flex-direction: column;
//   padding: 0.5rem;
//   position: relative;
//   backdrop-filter: blur(2px);
//   min-width: 160px; 
// `;

// const TopRow = styled.div`
//   display: flex;
//   align-items: center;
//   gap: 8px;
//   margin-bottom: 0.3rem;
// `;

// const OfflineBadge = styled.div`
//   display: flex;
//   align-items: center;
//   gap: 5px;
//   background-color: rgba(251, 146, 60, 0.75);
//   color: white;
//   padding: 3px 8px;
//   border-radius: 5px;
//   white-space: nowrap;
//   flex-shrink: 0;

//   .icon {
//     font-size: 0.85rem;
//     line-height: 1;
//   }

//   .timestamp {
//     font-size: 0.72rem;
//     font-weight: 600;
//     letter-spacing: 0.01em;
//   }

//   @media (max-width: 1024px) {
//     padding: 2px 6px;
//     .timestamp { font-size: 0.68rem; }
//   }

//   @media (max-width: 768px) {
//     padding: 2px 5px;
//     .timestamp { font-size: 0.63rem; }
//   }
// `;

// const gradientShift = keyframes`
//   0% { background-position: -200% center; }
//   100% { background-position: 200% center; }
// `;

// const pulse = keyframes`
//   0%, 100% { transform: scale(1); }
//   50% { transform: scale(1.05); }
// `;

// const LocationName = styled.p`
//   margin: 0;
//   opacity: 0;
//   animation: fadeIn 0.4s ease forwards, ${gradientShift} 2.5s linear infinite, ${pulse} 2s ease-in-out infinite;
//   font-weight: 1000;
//   white-space: nowrap;
//   font-size: 0.9rem;
//   cursor: pointer;

//   ${({ $isOnline }) =>
//     $isOnline
//       ? css`
//           background: linear-gradient(90deg, #5ca904 0%, #5ca904 30%, #00ffff 50%, #5ca904 70%, #5ca904 100%);
//           background-size: 200% auto;
//           background-clip: text;
//           -webkit-background-clip: text;
//           -webkit-text-fill-color: transparent;
//         `
//       : css`
//           background: linear-gradient(90deg, #ea580c 0%, #ea580c 30%, #00bfff 50%, #ea580c 70%, #ea580c 100%);
//           background-size: 200% auto;
//           background-clip: text;
//           -webkit-background-clip: text;
//           -webkit-text-fill-color: transparent;
//         `}

//   @keyframes fadeIn { to { opacity: 1; } }
// `;

// export default function SolenoidBoxComponent({ sensor }) {
//   const history = useHistory();
//   const state = useContext(GlobalState);

//   const [solenoid, setSolenoid] = React.useState({
//     ...sensor,
//     sensor_online: sensor.sensor_online === true || sensor.sensor_online === "1",
//   });
//   const [solenoidStatus, setSolenoidStatus] = React.useState(sensor.valve_on === "1");

//   const fetchData = async (id) => {
//     try {
//       const response = await axios.get(
//         `${process.env.REACT_APP_API}/sensor/solenoid?solenoid_id=${id}`,
//         { headers: { Authorization: state.token[0] } }
//       );

//       const data = response.data?.data;
//       if (data) {
//         setSolenoid({
//           solenoid_id: data.solenoid_id,
//           sensor_online: data.sensor_online === true || data.sensor_online === "1",
//           valve_on: data.valve_on,
//           updatedAt: data.updatedAt,
//           location_name: data.location_name || sensor.location_name,
//         });
//         setSolenoidStatus(data.valve_on === "1");
//       }
//     } catch (err) {
//       console.error("Error fetching solenoid data:", err);
//     }
//   };

//   const toggleSolenoid = async (id) => {
//     try {
//       setSolenoidStatus(prev => !prev);

//       const response = await axios.patch(
//         `${process.env.REACT_APP_API}/sensor/solenoid?solenoid_id=${id}`,
//         { valve_on: !solenoidStatus ? "1" : "0" },
//         { headers: { Authorization: state.token[0] } }
//       );

//       if (response.data) {
//         await fetchData(id);
//       }
//     } catch (err) {
//       console.error("Error toggling solenoid:", err);
//       setSolenoidStatus(prev => !prev);
//     }
//   };

//   React.useEffect(() => {
//     if (sensor.solenoid_id) {
//       fetchData(sensor.solenoid_id);
//       const interval = setInterval(() => fetchData(sensor.solenoid_id), 5000);
//       return () => clearInterval(interval);
//     }
//   }, [sensor.solenoid_id]);

//   return (
//     <Container>
//       <TopRow>
//         <ToggleButton
//           disabled={!editAccess(state.userAPI)}
//           id={solenoid.solenoid_id}
//           checked={solenoidStatus}
//           onClick={(e) => e.stopPropagation()}
//           onChange={() => toggleSolenoid(solenoid.solenoid_id)}
//         />

//         {!solenoid.sensor_online && solenoid.updatedAt && (
//           <OfflineBadge>
//             <span className="icon">⚠</span>
//             <span className="timestamp">{formatDate(solenoid.updatedAt)}</span>
//           </OfflineBadge>
//         )}
//       </TopRow>

//       <LocationName
//         $isOnline={solenoid.sensor_online}
//         onClick={() => history.push(`/solenoid/${solenoid.solenoid_id}/${solenoid.location_name}`)}
//       >
//         {/* {solenoid.location_name || "Unknown Location"} */}
//          {solenoid.location_name?.length > 15
//             ? solenoid.location_name.slice(0, 15)
//             : solenoid.location_name}
//       </LocationName>
//     </Container>
//   );
// }




// import axios from "axios";
// import React, { useContext, useEffect, useRef } from "react";
// import { useHistory } from "react-router-dom/cjs/react-router-dom";
// import { GlobalState } from "../../GlobalState.js";
// import ToggleButton from "../utils/ToggleButton";
// import { editAccess, formatDate } from "../utils/utils.js";
// import styled, { keyframes, css } from "styled-components";

// const Container = styled.div`
//   border-radius: 20px;  
//   display: flex;
//   flex-direction: column;
//   padding: 0.5rem;
//   position: relative;
//   backdrop-filter: blur(2px);
//   min-width: 160px; 
// `;

// const TopRow = styled.div`
//   display: flex;
//   align-items: center;
//   gap: 8px;
//   margin-bottom: 0.3rem;
// `;

// const OfflineBadge = styled.div`
//   display: flex;
//   align-items: center;
//   gap: 5px;
//   background-color: rgba(251, 146, 60, 0.75);
//   color: white;
//   padding: 3px 8px;
//   border-radius: 5px;
//   white-space: nowrap;
//   flex-shrink: 0;

//   .icon {
//     font-size: 0.85rem;
//     line-height: 1;
//   }

//   .timestamp {
//     font-size: 0.72rem;
//     font-weight: 600;
//     letter-spacing: 0.01em;
//   }

//   @media (max-width: 1024px) {
//     padding: 2px 6px;
//     .timestamp { font-size: 0.68rem; }
//   }

//   @media (max-width: 768px) {
//     padding: 2px 5px;
//     .timestamp { font-size: 0.63rem; }
//   }
// `;

// const TimestampWrapper = styled.div`
//   position: relative;
//   display: inline-flex;
//   align-items: center;

//   .tooltip {
//     position: absolute;
//     bottom: 100%;
//     left: 50%;
//     transform: translateX(-50%) translateY(0px);
//     background: white;
//     color: rgb(204, 72, 77);
//     font-size: 0.7rem;
//     font-weight: 800;
//     padding: 3px 8px;
//     border-radius: 4px;
//     white-space: nowrap;
//     opacity: 0;
//     pointer-events: none;
//     transition: opacity 0.2s ease, transform 0.2s ease;
//     margin-bottom: 6px;
//     z-index: 99;
//     box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);

//     &::after {
//       content: "";
//       position: absolute;
//       top: 100%;
//       left: 50%;
//       transform: translateX(-50%);
//       border: 4px solid transparent;
//       border-top-color: white;
//     }
//   }

//   &:hover .tooltip {
//     opacity: 1;
//     transform: translateX(-50%) translateY(-4px);
//   }

//   &.touch-active .tooltip {
//     opacity: 1;
//     transform: translateX(-50%) translateY(-4px);
//   }
// `;

// const gradientShift = keyframes`
//   0% { background-position: -200% center; }
//   100% { background-position: 200% center; }
// `;

// const pulse = keyframes`
//   0%, 100% { transform: scale(1); }
//   50% { transform: scale(1.05); }
// `;

// const LocationName = styled.p`
//   margin: 0;
//   opacity: 0;
//   animation: fadeIn 0.4s ease forwards, ${gradientShift} 2.5s linear infinite, ${pulse} 2s ease-in-out infinite;
//   font-weight: 1000;
//   white-space: nowrap;
//   font-size: 0.9rem;
//   cursor: pointer;

//   ${({ $isOnline }) =>
//     $isOnline
//       ? css`
//           background: linear-gradient(90deg, #5ca904 0%, #5ca904 30%, #00ffff 50%, #5ca904 70%, #5ca904 100%);
//           background-size: 200% auto;
//           background-clip: text;
//           -webkit-background-clip: text;
//           -webkit-text-fill-color: transparent;
//         `
//       : css`
//           background: linear-gradient(90deg, #ea580c 0%, #ea580c 30%, #00bfff 50%, #ea580c 70%, #ea580c 100%);
//           background-size: 200% auto;
//           background-clip: text;
//           -webkit-background-clip: text;
//           -webkit-text-fill-color: transparent;
//         `}

//   @keyframes fadeIn { to { opacity: 1; } }
// `;

// function useTouchTooltip(ref) {
//   useEffect(() => {
//     const el = ref.current;
//     if (!el) return;

//     let hideTimer;

//     const onTouchStart = (e) => {
//       e.preventDefault();
//       el.classList.add("touch-active");
//       clearTimeout(hideTimer);
//       hideTimer = setTimeout(() => el.classList.remove("touch-active"), 2500);
//     };

//     el.addEventListener("touchstart", onTouchStart, { passive: false });
//     return () => {
//       el.removeEventListener("touchstart", onTouchStart);
//       clearTimeout(hideTimer);
//     };
//   }, [ref]);
// }

// export default function SolenoidBoxComponent({ sensor }) {
//   const history = useHistory();
//   const state = useContext(GlobalState);

//   const tooltipRef = useRef(null);
//   useTouchTooltip(tooltipRef);

//   const [solenoid, setSolenoid] = React.useState({
//     ...sensor,
//     sensor_online: sensor.sensor_online === true || sensor.sensor_online === "1",
//   });
//   const [solenoidStatus, setSolenoidStatus] = React.useState(sensor.valve_on === "1");

//   const fetchData = async (id) => {
//     try {
//       const response = await axios.get(
//         `${process.env.REACT_APP_API}/sensor/solenoid?solenoid_id=${id}`,
//         { headers: { Authorization: state.token[0] } }
//       );

//       const data = response.data?.data;
//       if (data) {
//         setSolenoid({
//           solenoid_id: data.solenoid_id,
//           sensor_online: data.sensor_online === true || data.sensor_online === "1",
//           valve_on: data.valve_on,
//           updatedAt: data.updatedAt,
//           location_name: data.location_name || sensor.location_name,
//         });
//         setSolenoidStatus(data.valve_on === "1");
//       }
//     } catch (err) {
//       console.error("Error fetching solenoid data:", err);
//     }
//   };

//   const toggleSolenoid = async (id) => {
//     try {
//       setSolenoidStatus(prev => !prev);

//       const response = await axios.patch(
//         `${process.env.REACT_APP_API}/sensor/solenoid?solenoid_id=${id}`,
//         { valve_on: !solenoidStatus ? "1" : "0" },
//         { headers: { Authorization: state.token[0] } }
//       );

//       if (response.data) {
//         await fetchData(id);
//       }
//     } catch (err) {
//       console.error("Error toggling solenoid:", err);
//       setSolenoidStatus(prev => !prev);
//     }
//   };

//   React.useEffect(() => {
//     if (sensor.solenoid_id) {
//       fetchData(sensor.solenoid_id);
//       const interval = setInterval(() => fetchData(sensor.solenoid_id), 5000);
//       return () => clearInterval(interval);
//     }
//   }, [sensor.solenoid_id]);

//   return (
//     <Container>
//       <TopRow>
//         <ToggleButton
//           disabled={!editAccess(state.userAPI)}
//           id={solenoid.solenoid_id}
//           checked={solenoidStatus}
//           onClick={(e) => e.stopPropagation()}
//           onChange={() => toggleSolenoid(solenoid.solenoid_id)}
//         />

//         {!solenoid.sensor_online && solenoid.updatedAt && (
//           <OfflineBadge>
//             <span className="icon">⚠</span>
//             <TimestampWrapper ref={tooltipRef}>
//               <span className="tooltip">⚠ Solenoid is offline</span>
//               <span className="timestamp">{formatDate(solenoid.updatedAt)}</span>
//             </TimestampWrapper>
//           </OfflineBadge>
//         )}
//       </TopRow>

//       <LocationName
//         $isOnline={solenoid.sensor_online}
//         onClick={() => history.push(`/solenoid/${solenoid.solenoid_id}/${solenoid.location_name}`)}
//       >
//         {solenoid.location_name?.length > 15
//           ? solenoid.location_name.slice(0, 15)
//           : solenoid.location_name}
//       </LocationName>
//     </Container>
//   );
// }

import axios from "axios";
import React, { useContext, useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { GlobalState } from "../../GlobalState.js";
import ToggleButton from "../utils/ToggleButton";
import { editAccess, formatDate } from "../utils/utils.js";
import { formatOfflineDuration } from "../utils/formatOfflineDuration";
import styled, { css,keyframes } from "styled-components";

/* Identical to PumpStatusV2/V3's PbBlock */
const PbBlock = styled.div`
  position: relative;
  flex: 0 0 auto;
  width: fit-content;
  min-width: 180px;
  max-width: 340px;
  margin: 0.5rem;
  border-radius: 10px;
  overflow: hidden;
  border: 1px solid #e5e7eb;
  display: flex;
  transition: all 0.3s ease;

  @media (max-width: 480px) {
    flex: 1 1 100%;
    max-width: 100%;
    min-width: 0;
    margin: 0.3rem 0;
  }
`;

const AccentBar = styled.div`
  width: 5px;
  flex-shrink: 0;
  background: ${({ $isOnline }) => ($isOnline ? "#22C55E" : "#94A3B8")};
`;

const PbInner = styled.div`
  flex: 1;
  padding: 4px 4px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
`;

const TopRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
`;

/* Identical to PumpStatusV2's ToggleWrapper — plain filter tint, no clamp */
const ToggleWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;

  ${({ $isOnline }) =>
    !$isOnline
      ? css`
          filter: grayscale(1) opacity(0.7);
        `
      : css`
          filter: none;
        `}
`;

const PbMeta = styled.div`
  flex: 1;
  min-width: 0;
`;

const LocationName = styled.p`
  margin: 0;
  font-weight: 700;
  font-size: 0.85rem;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
  color: #111827;

  @media (max-width: 768px) {
    font-size: 0.75rem;
  }
`;

const StatusLine = styled.div`
  font-size: 0.7rem;
  font-weight: 600;
  color: ${({ $isOnline, $isOpen }) =>
    !$isOnline ? "#9CA3AF" : $isOpen ? "#16A34A" : "#6B7280"};

  @media (max-width: 768px) {
    font-size: 0.65rem;
  }
`;

const Badge = styled.span`
  font-size: 9.5px;
  font-weight: 500;
  padding: 2px 7px;
  border-radius: 8px;
  white-space: nowrap;
  flex-shrink: 0;
  background: ${({ $isOnline }) =>
    $isOnline ? "rgba(34,197,94,.12)" : "#F3F4F6"};
  color: ${({ $isOnline }) => ($isOnline ? "#15803D" : "#090a0e")};
`;

const BadgeStack = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 2px;
  flex-shrink: 0;
`;

const pulse = keyframes`
  0%, 100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.5;
    transform: scale(1.08);
  }
`;

const PlainDuration = styled.span`
  display: inline-block; /* Important */
  font-size: 10px;
  font-weight: 500;
  color: #d81111;
  white-space: nowrap;
  animation: ${pulse} 2s infinite ease-in-out;
  transform-origin: center;
`;

const OfflineBadge = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  background-color: rgba(251, 146, 60, 0.5);
  color: rgb(57, 56, 56);
  padding: 3px 8px;
  border-radius: 5px;
  white-space: nowrap;
  width: fit-content;

  .icon {
    font-size: 0.85rem;
    line-height: 1;
  }

  .timestamp {
    font-size: 0.7rem;
    font-family: Arial, sans-serif;
    font-weight: 700;
    letter-spacing: 0.01em;
  }

  @media (max-width: 768px) {
    padding: 2px 5px;
    gap: 3px;
    .timestamp { font-size: 0.65rem; }
    .icon { font-size: 0.65rem; }
  }
`;

const TimestampWrapper = styled.div`
  position: relative;
  display: inline-flex;
  align-items: center;

  .tooltip {
    position: absolute;
    bottom: 100%;
    left: 50%;
    transform: translateX(-50%) translateY(0px);
    background: white;
    color: rgb(204, 72, 77);
    font-size: 0.75rem;
    font-weight: 800;
    padding: 4px 10px;
    border-radius: 4px;
    white-space: nowrap;
    opacity: 0;
    pointer-events: none;
    transition: opacity 0.2s ease, transform 0.2s ease;
    margin-bottom: 6px;
    z-index: 99;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);

    &::after {
      content: "";
      position: absolute;
      top: 100%;
      left: 50%;
      transform: translateX(-50%);
      border: 4px solid transparent;
      border-top-color: white;
    }
  }

  &:hover .tooltip {
    opacity: 1;
    transform: translateX(-50%) translateY(-4px);
  }

  &.touch-active .tooltip {
    opacity: 1;
    transform: translateX(-50%) translateY(-4px);
  }
`;

/* Robust boolean coercion — handles booleans, "1"/"0", "true"/"false", numbers.
   Boolean("false") is a real trap since any non-empty string is truthy in JS. */
function toBool(value) {
  if (typeof value === "boolean") return value;
  if (typeof value === "number") return value === 1;
  if (typeof value === "string") {
    const v = value.trim().toLowerCase();
    return v === "1" || v === "true" || v === "on";
  }
  return Boolean(value);
}

function useTouchTooltip(ref) {
  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    let hideTimer;

    const onTouchStart = (e) => {
      e.preventDefault();
      el.classList.add("touch-active");
      clearTimeout(hideTimer);
      hideTimer = setTimeout(() => el.classList.remove("touch-active"), 2500);
    };

    el.addEventListener("touchstart", onTouchStart, { passive: false });
    return () => {
      el.removeEventListener("touchstart", onTouchStart);
      clearTimeout(hideTimer);
    };
  }, [ref]);
}

export default function SolenoidBoxComponent({ sensor }) {
  const history = useHistory();
  const state = useContext(GlobalState);

  const tooltipRef = useRef(null);
  useTouchTooltip(tooltipRef);

  const [solenoid, setSolenoid] = useState({
    ...sensor,
    sensor_online: toBool(sensor.sensor_online),
  });
  const [solenoidStatus, setSolenoidStatus] = useState(toBool(sensor.valve_on));

  const MAX_LENGTH = 15;
  const truncatedLocationName =
    solenoid.location_name?.length > MAX_LENGTH
      ? solenoid.location_name.slice(0, MAX_LENGTH)
      : solenoid.location_name;

  const fetchData = async (id) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API}/sensor/solenoid?solenoid_id=${id}`,
        { headers: { Authorization: state.token[0] } }
      );

      const data = response.data?.data;
      if (data) {
        setSolenoid({
          solenoid_id: data.solenoid_id,
          sensor_online: toBool(data.sensor_online),
          valve_on: data.valve_on,
          updatedAt: data.updatedAt,
          location_name: data.location_name || sensor.location_name,
        });
        setSolenoidStatus(toBool(data.valve_on));
      }
    } catch (err) {
      console.error("Error fetching solenoid data:", err);
    }
  };

  const toggleSolenoid = async (id) => {
    const previousStatus = solenoidStatus;
    try {
      setSolenoidStatus((prev) => !prev);

      const response = await axios.patch(
        `${process.env.REACT_APP_API}/sensor/solenoid?solenoid_id=${id}`,
        { valve_on: !previousStatus ? "1" : "0" },
        { headers: { Authorization: state.token[0] } }
      );

      if (response.data) {
        await fetchData(id);
      }
    } catch (err) {
      console.error("Error toggling solenoid:", err);
      setSolenoidStatus(previousStatus);
    }
  };

  useEffect(() => {
    if (sensor.solenoid_id) {
      fetchData(sensor.solenoid_id);
      const interval = setInterval(() => fetchData(sensor.solenoid_id), 5000);
      return () => clearInterval(interval);
    }
  }, [sensor.solenoid_id]);

  const isOnline = solenoid.sensor_online;

  const statusLabel = !isOnline
    ? "OFFLINE"
    : solenoidStatus
    ? "OPEN · running"
    : "CLOSED";

  return (
    <PbBlock>
      <AccentBar $isOnline={isOnline} />

      <PbInner>
        <TopRow>
          <ToggleWrapper $isOnline={isOnline}>
            <ToggleButton
              disabled={!editAccess(state.userAPI)}
              id={solenoid.solenoid_id}
              checked={solenoidStatus}
              onClick={(e) => e.stopPropagation()}
              onChange={() => toggleSolenoid(solenoid.solenoid_id)}
            />
          </ToggleWrapper>

          <PbMeta>
            <LocationName
              onClick={() =>
                history.push(`/solenoid/${solenoid.solenoid_id}/${solenoid.location_name}`)
              }
            >
              {truncatedLocationName}
            </LocationName>
          </PbMeta>

          <BadgeStack>
            <Badge $isOnline={isOnline}>{isOnline ? "online" : "offline"}</Badge>

            {!isOnline && (
              <PlainDuration>
                {formatOfflineDuration(solenoid.updatedAt)}
              </PlainDuration>
            )}
          </BadgeStack>
        </TopRow>
      </PbInner>
    </PbBlock>
  );
}